import {sortByGroupByValue} from '../../../../src/utils/sort.ts';
import type {ReaderListing} from '../reader-listing.ts';

export class Listings {
	private byId: Map<string, ReaderListing> = new Map();
	private listings: ReaderListing[] = [];

	toArray() {
		return Array.from(this.listings);
	}

	add(listing: ReaderListing) {
		this.listings.push(listing);
		this.byId.set(listing.id, listing);
	}

	get(id: string | undefined) {
		if (!id) {
			return undefined;
		}
		return this.byId.get(id);
	}

	at(index: number) {
		return this.listings.at(index);
	}

	getIndexOf(listing: ReaderListing) {
		return this.listings.indexOf(listing);
	}

	length() {
		return this.listings.length;
	}

	forEach(callback: (listing: ReaderListing) => void) {
		this.listings.forEach(callback);
	}

	sort(reverse: boolean) {
		this.listings.sort(({item: a}: ReaderListing, {item: b}: ReaderListing) => {
			if (b.sortOrder !== a.sortOrder) {
				return a.sortOrder - b.sortOrder;
			}

			return -1;
		});

		if (reverse) {
			this.listings.reverse();
		}
	}

	sortByGroups(order: 'asc' | 'desc') {
		this.listings.sort((a: ReaderListing, b: ReaderListing) =>
			sortByGroupByValue(a.groupByValue, b.groupByValue, order)
		);
		this.updateLinkedList();
	}

	updateLinkedList() {
		this.listings.forEach((listing: ReaderListing, index) => {
			// Clear any previous linked item
			listing.setNext(undefined);
			listing.number = index + 1;
			const previousListing = this.listings[index - 1];
			if (previousListing) {
				listing.setPrevious(previousListing);
				previousListing.setNext(listing);
			} else {
				listing.setPrevious(undefined);
			}
		});
	}

	getNextListing(startListing: ReaderListing, skipDone: boolean) {
		if (!skipDone) {
			return startListing.nextListing;
		}

		let pending = startListing.nextListing;
		if (!pending) {
			return;
		}

		while (pending && pending.item.getState().state === 'done') {
			pending = pending?.nextListing;
		}

		return pending;
	}

	getPreviousListing(startListing: ReaderListing, skipDone: boolean) {
		if (!skipDone) {
			return startListing.previousListing;
		}

		let pending = startListing.previousListing;
		if (!pending) {
			return;
		}

		while (pending && pending.item.getState().state === 'done') {
			pending = pending?.previousListing;
		}

		return pending;
	}
}
